export default __webpack_public_path__ + "static/media/lofo.e99d9fd4.jpg";